import "./index.css"
import { useLocation } from "react-router-dom"
import Header from "../../components/custom/header"
import Volunteer from "../volunteers/volunteer"
import { reversePayload } from "../../data/volunteer"
import { useVolunteer } from "../../context/volunteer"
import Tab from "../../components/holders/tab"
import { useGlobal } from "../../context/global"
import PageLoader from "../../components/info/pageloader"
import ListView from "../../components/holders/listView"

const Applicants = () => {
    const { volunteers } = useVolunteer()
    const { auth } = useGlobal()
    const location = useLocation()
    const stateTab = location.state?.tab

    const listMap = volunteer =>
        <Volunteer
            disabled={
                auth.user.roleID === 'ops-admin'
                    ? ['preacher-pending', 'admin-pending'].includes(volunteer.approval)
                    : auth.user.roleID === 'preacher'
                        ? ['ops-pending', 'admin-pending'].includes(volunteer.approval)
                        : false
            }
            key={volunteer.id}
            volunteer={reversePayload(volunteer)}
        />

    const sortConfig = [
        {
            name: "Name (A-Z)",
            key: 'name',
            asc: true
        },
        {
            name: "Name (Z-A)",
            key: 'name',
            asc: false
        },
        {
            name: "Latest",
            key: 'date',
            asc: false
        },
        {
            name: "Earliest",
            key: 'date',
            asc: true
        },
        {
            name: "Preacher (A-Z)",
            key: 'preacher',
            asc: true
        },
        {
            name: "Preacher (Z-A)",
            key: 'preacher',
            asc: false
        },
        {
            name: "Initiation Name (A-Z)",
            key: 'initiationName',
            asc: true
        },
        {
            name: "Initiation Name (Z-A)",
            key: 'initiationName',
            asc: false
        },
        {
            name: "Gender (M-F)",
            key: 'gender',
            asc: false
        },
        {
            name: "Gender (F-M)",
            key: 'gender',
            asc: true
        }
    ]

    const filterConfig = [
        {
            name: "Male Only",
            match: v => {
                const vol = reversePayload(v)
                return vol.gender === true
            }
        },
        {
            name: "Female Only",
            match: v => {
                const vol = reversePayload(v)
                return vol.gender === false
            }
        },
        {
            name: "Chanting >= 16 Rounds",
            match: v => {
                const vol = reversePayload(v)
                return parseInt(vol.rounds) >= 16
            }
        },
        {
            name: "Chanting < 16 Rounds",
            match: v => {
                const vol = reversePayload(v)
                return parseInt(vol.rounds) < 16
            }
        },
        {
            name: "Occupational Status: Student",
            match: v => {
                const vol = reversePayload(v)
                return vol.occupationalStatus === 'Student'
            }
        },
        {
            name: "Occupational Status: Working",
            match: v => {
                const vol = reversePayload(v)
                return vol.occupationalStatus === 'Working'
            }
        },
        {
            name: "Initiated Only",
            match: v => {
                const vol = reversePayload(v)
                return vol.hasInitiation === true || (vol.initiationName && vol.initiationName.trim().length > 0)
            }
        }
    ]

    return (
        <div className="aplc-root">
            <Header title={'Applicants'} />
            {volunteers ? (
                <div className="aplc-main">
                    {volunteers && (
                        <Tab
                            render
                            def={
                                stateTab !== undefined
                                    ? stateTab
                                    : auth.user.roleID === 'preacher'
                                        ? 1
                                        : (auth.user.roleID === 'admin' || auth.user.roleID === 'app-admin')
                                            ? 2
                                            : 0
                            }
                            tabs={[
                                {
                                    header: `Data Check (${volunteers[0].length})`,
                                    comp: <ListView
                                        list={volunteers[0]}
                                        sortConfig={sortConfig}
                                        filterConfig={filterConfig}
                                        defaultSortIndex={2}
                                        map={listMap}
                                    />
                                },
                                {
                                    header: `Screening (${volunteers[1].length})`,
                                    comp: <ListView
                                        list={volunteers[1]}
                                        sortConfig={sortConfig}
                                        filterConfig={filterConfig}
                                        map={listMap}
                                    />
                                },
                                {
                                    header: `Approval (${volunteers[2].length})`,
                                    comp: <ListView
                                        list={volunteers[2]}
                                        sortConfig={sortConfig}
                                        filterConfig={filterConfig}
                                        map={listMap}
                                    />
                                },
                            ]}
                        />
                    )}
                </div>
            ) : (
                <PageLoader text={'Loading applicants list...'} />
            )}
        </div>
    )
}

export default Applicants
